<template>
	<div
		class="square-box"
		:class="[`square-box-${theme}`, { 'cursor-pointer': clickable }]"
		@click="handleClick()"
	>
		<div
			v-if="focused"
			class="square-box-focused tw-flex tw-justify-center tw-items-center"
		>
			<p class="content-name tw-m-0 tw-text-center">{{ name }}</p>
		</div>
		<div
			class="square-box-content tw-flex tw-justify-center tw-items-center"
			:class="[{ 'square-box-content-checked': checked }]"
		>
			<div>
				<v-checkbox
					v-if="indexTab === 0 || indexTab === 1"
					class="check-active"
					color="warning"
					:title="statedJob"
					v-model="statusJob"
					@change="$emit('onChangeStatus', statusJob)"
				></v-checkbox>
				<check-icon class="check-icon" :color="checked ? 'success' : ''" />
			</div>
			<p class="content-name tw-m-0 tw-text-center">{{ name }}</p>
			<div v-if="displayActions" class="content-actions">
				<app-btn
					v-if="(indexTab === 0 || indexTab === 2) && statusJob"
					:img="`${$imageUrl}/edit.svg`"
					text="Configurar Módelo Directriz"
					@click-icon="$emit('onEditClick')"
				/>
				<app-btn
					v-if="statusJob && indexTab === 0"
					img="/static/img/evaluation/icons/description.svg"
					text="Descripción de Puestos"
					@click-icon="$emit('onDescriptionClick')"
				/>
				<app-btn
					v-if="statusJob && indexTab === 0"
					img="/static/img/eye.svg"
					:text="changeText"
					:disabled="validationAI"
					@click-icon="$emit('onViewPdf')"
				/>
				<app-btn
					v-if="(indexTab === 0 || indexTab === 2) && statusJob"
					:img="`${$imageUrl}/delete-button.svg`"
					text="Eliminar Puesto de Trabajo"
					@click-icon="$emit('onDeleteClick')"
				/>
			</div>
		</div>
	</div>
</template>

<script>
import CheckIcon from '@/modules/shared/components/icons/check-icon';

export default {
	name: 'SquareBox',
	data() {
		return {
			statusJob: null,
		};
	},
	created() {
		this.statusJob = this.status;
	},
	components: { CheckIcon },
	props: {
		name: {
			default: () => '',
		},
		checked: {
			default: () => false,
		},
		job: {
			default: () => {},
		},
		focused: {
			default: () => false,
		},
		displayActions: {
			default: () => true,
		},
		theme: {
			default: () => 'primary',
		},
		clickable: {
			default: () => false,
		},
		status: {
			type: Boolean,
			default: true,
		},
		indexTab: {
			type: Number,
			default: null,
		},
	},
	methods: {
		handleClick() {
			if (!this.clickable) return;
			this.$emit('click');
		},
	},
	computed: {
		validationAI() {
			const ai = this.job.additionalInformation;
			if (!ai) return true;
			const has = k => Object.prototype.hasOwnProperty.call(ai, k);
			return !(has('immediateBoss') && has('jobHeReplaces') && has('jobItReplaces'));
		},
		changeText() {
			const isValid = this.validationAI;
			if (!isValid) {
				return 'Detalles Descripción de Puestos';
			}
			return 'Completar Configuración del Puestos';
		},
		statedJob() {
			return this.statusJob ? 'Desactivar' : 'Activar';
		},
	},
	watch: {
		status: {
			handler(newVal) {
				this.statusJob = newVal;
			},
		},
	},
};
</script>

<style lang="scss" scoped>
.square-box {
	border-radius: 10px;
	box-shadow: 0 2px 10px 0 rgba(242, 242, 242, 0.5);
	background-color: #ffffff;
	padding-bottom: 90%;
	position: relative;
	user-select: none;

	&.square-box-primary {
		border: solid 2px var(--app-color-primary);
	}
	&.square-box-secondary {
		border: solid 2px var(--app-color-secondary);
		.square-box-content {
			&.square-box-content-checked {
				.content-name {
					color: var(--app-color-primary);
				}
			}
			.content-name {
				color: var(--app-color-secondary);
			}
		}
	}

	.square-box-focused,
	.square-box-content {
		position: absolute;
		top: 0;
		left: 0;
		right: 0;
		bottom: 0;
	}

	.square-box-focused {
		z-index: 1;
		background: var(--app-color-primary);
		.content-name {
			color: #ffffff !important;
			font-size: 16px;
			padding: 0 10px;
			line-height: 16px;
		}
	}
	.square-box-content {
		padding: 20px 10px;
		text-align: center;
		.content-name {
			color: var(--app-color-primary);
			font-size: 14px;
			line-height: 14px;
		}
		.check-icon {
			position: absolute;
			top: 5px;
			right: 5px;
			width: 20px;
		}
		.check-active {
			position: absolute;
			top: -15px;
			left: 5px;
		}
		.content-actions {
			position: absolute;
			bottom: 5px;
			left: 0;
			right: 0;
		}
	}
}
</style>



// WEBPACK FOOTER //
// src/modules/job-profile/components/content/c-square-box.vue